import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { Venue } from '../../../../../../shared/models/venue.model';
import { Event } from '../../../../../../shared/models/event.model';
import { ActivatedRoute } from '@angular/router';
import { EventMonitorInfo } from '../../models/event-monitor-info';
import { ScheduleManagerService } from '../../service/schedule-manager.service';
import { range } from '../../../../../../shared/util/helper';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { BaseComponent } from '../../../../../../shared/custom-components/base-component/base-component.component';
import { SchedulerMessagesEnum } from '../../enum/scheduler-messages.enum';
import { MOI } from '../../../../../../shared/enums/moi.enum';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-scheduler-monitor-report',
  templateUrl: './scheduler-monitor-report.component.html',
  styleUrls: ['./scheduler-monitor-report.component.scss']
})
export class SchedulerMonitorReportComponent extends BaseComponent implements OnInit {
  schedulerMessagesEnum = SchedulerMessagesEnum;
  arr: number[] = Array.from(Array(10).keys());
  venues: Venue[] = [];
  events: EventMonitorInfo[];
  selectedBusinessDate: Date = new Date();
  siteId: number;
  id: string;


  constructor(private route: ActivatedRoute, private scheduleService: ScheduleManagerService, private zone: NgZone,
              public translate: TranslateService) {
    super();
    this.route.queryParams.subscribe(params => {
      this.siteId = Number(params['siteId']);
      this.id = params['id'];
      const businessDate = moment(params['businessDate'], 'DD-MM-YYYY');
      if (businessDate.isValid()) {
        this.selectedBusinessDate = businessDate.toDate();
      }
    });
  }


  @HostListener('window:onParentPaste', ['$event'])
  onCallAngularService(e: CustomEvent) {
    // Run your service call here
    this.processParentMessage(e.detail);
  }

  ngOnInit() {
    this.scheduleService.apiGetVenues(this.siteId).subscribe((venues) => {
      this.venues = venues;
    });
    this.loadData();

  }

  loadData() {
    this.scheduleService.apiGetMonitorInfo(this.siteId, this.selectedBusinessDate).subscribe((res) => {
      this.events = res;

      // load state and update events as scheduled if needed
      const eids = this.getStateFromStorage();
      if (eids) {
        const eidsArr = eids.split(',').map((e: string) => parseInt(e, 10));
        this.events.map((e: EventMonitorInfo) => {
          const exists = eidsArr.find(e1 => e1 === e.eventId);
          if (exists) {
            e.scheduled = true;
          }
        });
      }
    });
  }

  get sequences(): any[] {
    if (this.events) {
      const maxsequence = Math.max(...this.events.map(o => o.eventSequence), 0);
      return range(1, maxsequence);
    }
    return [];
  }

  getEvent(venueId: number, sequence: number) {
    if (!this.events) {
      return null;
    }

    return this.events.find(e => e.venueId === venueId && e.eventSequence === sequence);
  }

  onCopy(venueId: number) {
    if (!this.isValidOpener()) {
      Swal.fire('Please reopen this report from the schedule manager.');
      return;
    }

    // get events to copy
    let events: EventMonitorInfo[] = this.events.filter(e => e.venueId === venueId && e.selected);
    if (!events.length) {
      events = this.events.filter(e => e.venueId === venueId);
    }

    parent.postMessage(events, location.origin);

    if (events.length) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: this.translate.instant(this.tranKey(MOI.SCHEDULE_MANAGER, this.schedulerMessagesEnum.EventsCopied), {count: events.length}),
        showConfirmButton: false,
        toast: true,
        timer: 1500
      });
    }


  }

  // go() {
  //   parent.postMessage('pp', location.origin);
  //   // window.close();
  // }
  //
  // test() {
  //   this.zone.runOutsideAngular(() => {
  //     const w: any = window.parent;
  //     w.ping();
  //    // window.opener.ping();
  //     // opener.ping();
  //   //  window.opener.document.ping();
  //   });
  //
  // }

  isValidOpener(): boolean {
    return opener.document.getElementById('popupIdentifier') !== null &&
      opener.document.getElementById('popupIdentifier').innerText == this.id;
  }

  onDateChanged() {
    this.loadData();
  }

  processParentMessage(events: EventMonitorInfo[]) {
    events.forEach((e: Event) => {
      const ei = this.events.find(ei => ei.eventId === e.eventId);
      if (ei) {
        ei.scheduled = true;
        ei.selected = false;
      }
    });
    this.saveStateToStorage();
  }

  get storageKey() {
    return this.siteId + '_' + moment(this.selectedBusinessDate).format('YYYY-MM-DD');
  }

  getStateFromStorage(): string {
    return sessionStorage.getItem(this.storageKey);
  }


  saveStateToStorage() {
    const scheduledEvents = this.events.filter(e => e.scheduled);
    const eventIds = [];
    scheduledEvents.forEach(e => {
      eventIds.push(e.eventId);
    });
    if (eventIds.length) {
      sessionStorage.setItem(this.storageKey, eventIds.join(','));
    }
  }

  resetStatus() {
    const keyName = this.siteId + '_' + moment(this.selectedBusinessDate).format('YYYY-MM-DD');
    sessionStorage.removeItem(this.storageKey);
    this.events.forEach(e => {
      e.scheduled = false;
    });
  }

}
